import React from 'react';
import SharedPageLayout from './layout/SharedPageLayout';
import { Card } from './ui/card';
import { Badge } from './ui/badge';
import { Mail } from 'lucide-react';

const Press = ({ onBack, onLogin, onRegister, navigateTo }) => {
  return (
    <SharedPageLayout
      title="Press & Media | Lexa.run"
      description="Product information and media inquiries for Lexa.run."
      onBack={onBack}
      onLogin={onLogin}
      onRegister={onRegister}
      navigateTo={navigateTo}
    >
      {/* Hero Section */}
      <section className="pt-16 pb-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <Badge variant="outline" className="mb-4 text-purple-600 border-purple-200">
            News & Media
          </Badge>
          <h1 className="text-4xl md:text-5xl font-extrabold tracking-tight mb-6">
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-purple-600 to-blue-600">
              Press Room
            </span>
          </h1>
          <p className="text-xl text-gray-600">
            Product information and a direct contact for media inquiries.
          </p>
        </div>
      </section>

      <section className="py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Card className="p-8 border-gray-200">
            <h2 className="text-2xl font-semibold mb-4">About Lexa</h2>
            <p className="text-gray-600 leading-relaxed">
              Lexa brings API testing, browser flows, test suites, and Sprint QA
              into one workspace. It is built by two QA professionals with 20
              years of experience each in manual testing and automation.
            </p>
            <p className="mt-4 text-gray-600 leading-relaxed">
              For product information, interviews, or current media assets,
              contact our team using the address below.
            </p>
          </Card>
        </div>
      </section>

      {/* Contact */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-purple-100 mb-6">
            <Mail className="w-8 h-8 text-purple-600" />
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            Media Inquiries
          </h2>
          <p className="text-gray-600 mb-6">
            For press inquiries, interviews, or media requests, please contact:
          </p>
          <a 
            href="mailto:press@lexa.run"
            className="inline-flex items-center px-6 py-3 rounded-full bg-purple-600 text-white hover:bg-purple-700 font-medium transition-colors"
          >
            <Mail className="w-5 h-5 mr-2" />
            press@lexa.run
          </a>
        </div>
      </section>
    </SharedPageLayout>
  );
};

export default Press;
